<template>
  <div class="books-edit">
    <!-- Add Modal 'Are you sure?'' -->
    <RwvPostEdit
    :postData="book"
    :savingAlert="showSavingAlert"
    :savedAlert="showSavedAlert"
    :errorAlert="showErrorAlert"
    :error="error"
    :categories="categories"
    :isBook="true"
    :postSlug="$attrs.slug"
    @submit="onSubmit"
    @delete="onDelete"
    @reset="onReset">
      <template v-slot:tabs>
          <!-- Links -->
          <b-tab title="Links">
            <p class="text-muted small">
              Der jeweilige Block kann zum ändern der Reihenfolge nach unten gezogen werden.
            </p>
            <draggable v-model="book.urls">
              <div class="draggable-child multiple urls"
                v-for="(url, index) in book.urls"
                :key="url.link">

                <h6>Link {{ index + 1 }}</h6>

                <b-form-row>
                  <b-col>
                    <b-form-group
                      :id="'input-group-url-title-' + index"
                      :label-for="'input-url-title-' + index">

                      <b-form-input
                        :id="'input-url-title' + index"
                        v-model="url.title"
                        required
                        placeholder="Link Titel"
                        v-b-tooltip.hover
                        title="Link Titel">
                        </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      :id="'input-group-url-icon-slug-' + index"
                      :label-for="'input-url-icon-slug-' + index">

                      <b-form-input
                        :id="'input-url-icon-slug-' + index"
                        v-model="url.iconSlug"
                        placeholder="Icon Slug"
                        v-b-tooltip.hover
                        title="Icon">
                        </b-form-input>

                      <p class="text-muted small">
                        Leerlassen -> kein Icon; Mögliche Icons <a href='http://material.io/icons' target='_blank'> hier.</a>
                      </p>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col>
                    <b-form-group
                      :id="'input-group-url-description-' + index"
                      :label-for="'input-url-description-' + index">

                      <b-form-input
                        :id="'input-url-description-' + index"
                        v-model="url.description"
                        required
                        placeholder="Beschreibung"
                        v-b-tooltip.hover
                        title="Link Beschreibung">
                        </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col>
                    <b-form-group
                      :id="'input-group-url-link-' + index"
                      :label-for="'input-url-link-' + index">

                      <b-form-input
                        :id="'input-url-link-' + index"
                        v-model="url.link"
                        required
                        placeholder="Link URL"
                        v-b-tooltip.hover
                        title="Link URL">
                        </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-button
                      size="sm"
                      block
                      variant="outline-danger"
                      v-on:click="deleteLink(index)"
                      v-b-tooltip.hover
                      title="Entfernt diese URL">
                      <i class="material-icons">delete</i>
                    </b-button>
                  </b-col>
                </b-form-row>
              </div>
            </draggable>

            <b-button
              variant="outline-primary"
              v-on:click="addLink()">
              Link hinzufügen
            </b-button>

          </b-tab>

          <!-- ISBNs -->
          <b-tab title="ISBNs">
            <p class="text-muted small">
              Der jeweilige Block kann zum ändern der Reihenfolge nach unten gezogen werden.
            </p>
            <draggable v-model="book.isbns">
              <div class="draggable-child multiple isbns"
                v-for="(isbn, index) in book.isbns"
                :key="isbn.isbn">
                <b-form-row>
                  <b-col>
                    <b-form-group
                      :id="'input-group-isbn-titel-' + index"
                      :label-for="'input-isbn-titel-' + index">

                      <b-form-input
                        :id="'input-isbn-titel' + index"
                        v-model="isbn.title"
                        required
                        placeholder="ISBN Titel"
                        v-b-tooltip.hover
                        title="ISBN Titel">
                        </b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group
                      :id="'input-group-isbn-isbn-' + index"
                      :label-for="'input-isbn-isbn-' + index">

                      <b-form-input
                        :id="'input-isbn-isbn-' + index"
                        v-model="isbn.isbn"
                        required
                        placeholder="ISBN"
                        v-b-tooltip.hover
                        title="ISBN">
                        </b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col cols="2" v-if="isbn.isbn">
                    <b-button
                      size="sm"
                      block
                      v-b-tooltip.hover
                      :href="'https://www.google.com/search?hl=de&tbo=p&tbm=bks&q=isbn:' + isbn.isbn.replace(/-/g, '') + '&num=10'"
                      target="_blank"
                      title="Zeige Buch mit ISBN auf Google"
                      variant="outline">
                      <i class="material-icons">remove_red_eye</i>
                    </b-button>
                  </b-col>
                  <b-col cols="2">
                    <b-button
                      size="sm"
                      block
                      variant="outline-danger"
                      v-on:click="deleteIsbn(index)">
                      <i class="material-icons">delete</i>
                    </b-button>
                  </b-col>
                </b-form-row>
              </div>
            </draggable>

            <b-button
              variant="outline-primary"
              v-on:click="addIsbn()">
              ISBN hinzufügen
            </b-button>
          </b-tab>
      </template>

      <template v-slot:inListPreview>

        <h6>Ansicht auf der Startseite</h6>

        <RwvBookTile
          :book="book">
        </RwvBookTile>
      </template>
    </RwvPostEdit>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";

import RwvBookTile from "@/components/Books/BookTile";
import RwvPostEdit from "@/components/Posts/PostEdit";

import draggable from 'vuedraggable'

import {
  slugify
} from "@/common/slugify"
import {
  BOOK_PUBLISH,
  BOOK_EDIT,
  BOOK_DELETE,
  FETCH_BOOK,
  BOOK_RESET_STATE
} from "@/store/actions.type";

export default {
  title () {
    return `Bearb.: ${this.book.slug} | So wird's gemacht`
  },
  components: {
    RwvPostEdit,
    RwvBookTile,
    draggable
  },
  props: {
    previousBook: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      srcBook: {},
      error: {
        title: "",
        message: "",
        stack: ""
      },
      categories: {
        "repair": "Buch"
      },
      showSavingAlert: false,
      showSavedAlert: false,
      showErrorAlert: false
    }
  },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.dispatch(BOOK_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    // SO: https://github.com/vuejs/vue-router/issues/1034
    // If we arrive directly to this url, we need to fetch the book
    await store.dispatch(BOOK_RESET_STATE);
    if (to.params.slug !== undefined) {
      await store.dispatch(
        FETCH_BOOK,
        {
          slug: to.params.slug,
          prevBook: to.params.previousBook
        }
      );
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(BOOK_RESET_STATE);
    next();
  },
  created() {
    this.srcBook = JSON.parse(JSON.stringify(this.book));
  },
  computed: {
    ...mapGetters(["book","books"])
  },
  methods: {
    addLink() {
      this.book.urls.push({url:"", link: "", description: "", iconSlug: ""})
    },
    deleteLink(urlIndex) {
      this.book.urls.splice(urlIndex, 1)
    },
    addIsbn() {
      this.book.isbns.push({title: "", isbn: ""})
    },
    deleteIsbn(isbnIndex) {
      this.book.isbns.splice(isbnIndex, 1)
    },
    onSubmit() {
      var me = this;
      var slug = me.srcBook.slug;
      let action = slug ? BOOK_EDIT : BOOK_PUBLISH;
      // Start Spinner
      me.showSavingAlert = true;
        console.log(content)

      // Remove Content Ids
      for (var content of me.book.content) {
        delete content.id;
        console.log(content)
      }
      me.book.slug = slugify(me.book.slug)
      // me.$store.dispatch()

      me.$store
        .dispatch(action)
        .then(({ data }) => {
          this.$bvToast.toast("Die Daten wurden erfolgreich gespeichert!", {
            title: "Gespeichert",
            variant: 'success'
          })
            // toaster: 'b-toaster-top-center'
          me.showSavingAlert = false;
        })
        .catch(({ response }) => {
          me.showSavingAlert = false;
          if (response) {
          console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
          // me.$bvModal.show("modal-error")
        });
    },
    onDelete() {
      var me = this;
      me.$store
        .dispatch(BOOK_DELETE, me.book.slug)
        .then(({ data }) => {
          // this.$bvToast.toast("Das Buch wurde gelöscht!", {
          //   title: "Gelöscht",
          //   variant: 'success'
          // })
          this.$router.push({ name: "dashboard" });
        })
        .catch(({ response }) => {
          if (response) {
            console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
        });
    },
    onReset() {
      this.book = JSON.parse(JSON.stringify(this.srcBook));
    }
  },
}
</script>


<style lang="scss">
.books-edit {
  overflow: hidden;
}
</style>
